module.exports = __webpack_public_path__ + "img/close_popup.d89baf03.svg";